import React from "react";

const Description = ({ color = "#FFC121", width = 28, height = 28 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.0792 22.5615C21.1854 24.4498 18.7214 25.6604 16.0694 26.0055C13.4173 26.3506 10.7256 25.8109 8.41155 24.4701L2.46037 26.0631L4.05337 20.1119C-1.1769 11.2014 6.67743 0.100475 16.8124 2.10786C16.8124 2.10786 16.8124 2.07778 16.8275 2.10786C26.2166 3.80507 29.9535 15.8355 23.0792 22.5615Z"
      fill={color}
    />
    <path
      d="M14.5178 21.0877C14.0711 21.0877 13.6427 20.9103 13.3268 20.5944C13.011 20.2786 12.8335 19.8502 12.8335 19.4035V14.2705C12.8378 13.8267 13.0171 13.4024 13.3326 13.0901C13.648 12.7777 14.0739 12.6025 14.5178 12.6025C14.9617 12.6025 15.3877 12.7777 15.7031 13.0901C16.0185 13.4025 16.1978 13.8267 16.2021 14.2706V19.4035C16.2021 19.8502 16.0246 20.2786 15.7088 20.5944C15.3929 20.9103 14.9645 21.0877 14.5178 21.0877Z"
      fill="#F6F7F9"
    />
    <path
      d="M16.2021 8.56752C16.1974 9.00343 16.0209 9.41988 15.711 9.72647C15.4011 10.033 14.9828 10.205 14.5468 10.205C14.1109 10.205 13.6926 10.033 13.3827 9.72643C13.0728 9.41984 12.8963 9.00338 12.8916 8.56747C12.8963 8.13156 13.0728 7.7151 13.3827 7.40852C13.6926 7.10194 14.1109 6.92999 14.5469 6.92999C14.9828 6.93 15.4012 7.10197 15.7111 7.40856C16.021 7.71515 16.1974 8.13161 16.2021 8.56752Z"
      fill="#F6F7F9"
    />
  </svg>
);

export default Description;
